import {DateConverter} from "../lang/dateconverter";
import moment from "moment";
//Future is negative
function getDifference(date) {

    //If not in range throws error
    let today=new DateConverter();
    today.setCurrentDate();
    if (!today.isNepaliRange(date.year,date.month,date.day)){
        throw new Error('Invalid date');
    }
    return today.getNepaliDateDifferenceS(date.year,date.month,date.day);

}

function parseDate(value){
    let params=value.split("-");

    if (params.length !== 3){
        //Should not come here but just in case
        throw new Error("Invalid date");
    }
    return {year:parseInt(params[0]),month:parseInt(params[1]),day:parseInt(params[2]) }
}

function validatedateFormat(value){
    const pattern = /^(?:19|20|21)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/
    return pattern.test(value);
}

function validatemessage(value){
    if(!validatedateFormat(value)){
        return "Invalid date"
    }
    let diff;

    try {
        let date=parseDate(value);
         diff=getDifference(date);
    }catch(e){
        return  e.message;
    }
    return diff;


}




export const validationMixin = {
    data() {
        return {
            rules: {
                required: value => !!value || "Required.",
                email: value => value && (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'E-mail must be valid') || true,
                mobile_number: value => value && value.length >= 10 && value.length <= 15 || "Mobile number should be at least 10 character",
                international_number: value => value && value.length <= 12 || "The number shouldn't be maximum than 12 characters",
                landline_number: value => value && value.length >= 7 && value.length <= 10 || "Landline number should be at least 7 character",
                // fileRequired: value => {
                //     let message = "Required";
                //     if (value) {
                //         if (value.name !== undefined)
                //             message = true;
                //     }
                //     return message;
                // },
                fileRequired: value => (value && value.name) || 'Required',
                afterToday: value => {
                    let difformessage=validatemessage(value);
                    if (typeof difformessage == "string")return difformessage;

                    return difformessage<=0 || 'Date cannot be of past';
                },
                beforeToday: value => {
                    let difformessage=validatemessage(value);
                    if (typeof difformessage == "string")return difformessage;

                    return difformessage>=0 || 'Date cannot be of future';
                },
                beforeTodayEng :value=>{
                    let today_date = new Date().toISOString().substr(0, 10);
                    if(!(validatedateFormat(value)))return "Invalid date";
                    return moment(value).isSameOrBefore(today_date) || "Date cannot be of future.";



                },
                afterTodayEng :value=>{
                    let today_date = new Date().toISOString().substr(0, 10);
                    if(!(validatedateFormat(value)))return "Invalid date";
                    return moment(value).isSameOrAfter(today_date) || "Date cannot be of past.";


                },
                multipleSelectRequired: value => {
                    if (value.length === 0) {
                        return "Required"
                    }
                    return true;
                },
                selectRules: value => {
                    if (!value.id) {
                        return "Required"
                    }
                    return true;
                },
                dobValidityDate: value => moment(value).isBefore(moment.now()) || "Date of birth cannot be of the future ",
            },
        }
    }
};
